/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Gmail connection status (no tokens exposed)
 * @export
 * @interface GmailAccountStatus
 */
export interface GmailAccountStatus {
    /**
     * 
     * @type {number}
     * @memberof GmailAccountStatus
     */
    readonly id: number;
    /**
     * The Gmail email address linked to the user
     * @type {string}
     * @memberof GmailAccountStatus
     */
    gmailEmail: string;
    /**
     * Whether the Gmail account is currently connected
     * @type {boolean}
     * @memberof GmailAccountStatus
     */
    isActive: boolean;
    /**
     * OAuth scopes granted by the user
     * @type {Array<string>}
     * @memberof GmailAccountStatus
     */
    scopes: Array<string>;
    /**
     * When the Gmail account was connected
     * @type {Date}
     * @memberof GmailAccountStatus
     */
    connectedAt: Date;
    /**
     * When the Gmail account was last used to send email
     * @type {Date}
     * @memberof GmailAccountStatus
     */
    lastUsedAt?: Date | null;
}

/**
 * Check if a given object implements the GmailAccountStatus interface.
 */
export function instanceOfGmailAccountStatus(value: object): value is GmailAccountStatus {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('gmailEmail' in value) || value['gmailEmail'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('connectedAt' in value) || value['connectedAt'] === undefined) return false;
    return true;
}

export function GmailAccountStatusFromJSON(json: any): GmailAccountStatus {
    return GmailAccountStatusFromJSONTyped(json, false);
}

export function GmailAccountStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GmailAccountStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'gmailEmail': json['gmailEmail'],
        'isActive': json['isActive'],
        'scopes': json['scopes'],
        'connectedAt': (new Date(json['connectedAt'])),
        'lastUsedAt': json['lastUsedAt'] == null ? undefined : (new Date(json['lastUsedAt'])),
    };
}

export function GmailAccountStatusToJSON(json: any): GmailAccountStatus {
    return GmailAccountStatusToJSONTyped(json, false);
}

export function GmailAccountStatusToJSONTyped(value?: Omit<GmailAccountStatus, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gmailEmail': value['gmailEmail'],
        'isActive': value['isActive'],
        'scopes': value['scopes'],
        'connectedAt': ((value['connectedAt']).toISOString()),
        'lastUsedAt': value['lastUsedAt'] == null ? undefined : ((value['lastUsedAt'] as any).toISOString()),
    };
}

